export default "__VITE_ASSET__DyXnohgG__"